import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import './AirDuct.scss';
import { useLocation, useNavigate } from "react-router-dom";
import Faq from "react-faq-component";
// images
import AreaData from './AreaData'
import AllServicesData from '../ServicesPage/AreaData'
import ReactCompareImage from "react-compare-image";
import BookAnAppointment from "../BookAnAppointment/BookAnAppointment";
import GenesisAiContent from "../GenesisAiContent/GenesisAiContent";
import emailjs from 'emailjs-com';
import img11 from '../../Images/11.jpg'
import img12 from '../../Images/12.jpg'
import img22 from '../../Images/22.jpg'
import img23 from '../../Images/23.jpg'

export default function AirDuct({ CitiePhone, locationsMain, CitiesData }) {

    const location = useLocation()
    const navigate = useNavigate()
    const [FormSubmiting, setFormSubmiting] = useState(false);
    const [response, setResponse] = useState({});
    const url = new URL(window.location.href);

    const fireRocketCall = () => {
        if (typeof window === "undefined") return;
        if (url.searchParams.get("spg") !== "o") return;
        if (typeof window.oaiq !== "function") return;
        const eventName = "rocket_air_duct_phone_call";
        try {
            window.oaiq("measure", "custom", { type: "custom" }, {
                custom_event_name: eventName,
                event_id: `${eventName}-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`,
            });
        } catch (e) { }
    };

    function sendEmail(e) {
        // setFormSubmiting(true)
        setFormSubmiting(true)
        e.preventDefault();    //This is important, i'm not sure why, but the email won't send without it

        emailjs.sendForm('service_fqud6um', 'template_vdkxpnd', e.target, 'QeqW-bXHRNjRmhZ6I')
            .then((result) => {
                setFormSubmiting(false)
                navigate(`/thankscontact?url=${location.pathname + location.search}`)
            }, (error) => {
                console.log(error.text);
            });
    }
    // Faqs
    const data = {
        title: "",
        rows: [
            {
                "title": "WHY CHOOSE ROCKET AIRCARE?",
                "content": "Rocket AirCare stands out with years of expertise and a commitment to excellence. Our professional team uses state-of-the-art equipment and techniques to ensure your air ducts are thoroughly cleaned, promoting healthier indoor air quality. We pride ourselves on reliable service and customer satisfaction."
            },
            {
                "title": "WHAT SERVICES DO YOU OFFER?",
                "content": "We provide a wide range of services, including residential and commercial air duct cleaning, dryer vent cleaning, air duct inspections, air quality testing, and routine maintenance. Our goal is to optimize your HVAC system's performance and keep your air fresh and clean."
            },
            {
                "title": "HOW MUCH DO YOUR SERVICES COST?",
                "content": "Our air duct cleaning starts at just $99, and dryer vent cleaning is $79. Additionally, we offer free consultations for any repair needs, ensuring you get a clear understanding of the work required before committing."
            },
            {
                "title": "CAN YOU CLEAN AND REPAIR AT THE SAME TIME?",
                "content": "Absolutely! Rocket AirCare specializes in providing same-day cleaning and repair services. If we identify any damage during the inspection, we can address it on the spot to save you time and restore your system's efficiency."
            },
            {
                "title": `DO YOU PROVIDE SERVICES SURROUNDING ${CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "YOUR AREA"}?`,
                "content": `Yes, we proudly serve ${CitiesData && CitiesData.City ? CitiesData.City : "Your Area"} and the surrounding regions. Our service area extends to a 75-mile radius, ensuring that homes and businesses in nearby towns can benefit from our top-quality air care services.`
            },
            {
                "title": "HOW DO I BOOK AN APPOINTMENT?",
                "content": `Booking with Rocket AirCare is simple! Call us at <a href='tel:${CitiePhone}'>${CitiePhone}</a> or complete our <a href='#book'>online booking form</a>. Our team will confirm your appointment and be ready to assist you at your convenience.`
            },
            {
                "title": "HOW OFTEN SHOULD AIR DUCTS BE CLEANED?",
                "content": "We recommend having your air ducts cleaned every 3 to 5 years, depending on factors such as pet ownership, allergies, or recent renovations. Regular cleaning ensures better air quality and extends the lifespan of your HVAC system."
            },
            {
                "title": "WHY IS DRYER VENT CLEANING IMPORTANT?",
                "content": "Dryer vent cleaning prevents lint buildup, reducing the risk of fires and improving your dryer's efficiency. Regular cleaning can also lower energy costs and prolong your appliance's lifespan."
            }
        ]
    };
    const styles = {
        bgColor: '#FBF6E9',
        titleTextColor: '#182d43',
        titleTextSize: '18px',
        rowTitleColor: '#182d43',
        rowTitleTextSize: '19px',
        rowContentColor: '#242424',
        rowContentTextSize: '17px',
        // rowContentTextWeight: '600',
        rowContentPaddingTop: '10px',
        rowContentPaddingBottom: '10px',
        rowContentPaddingLeft: '5px',
        rowContentPaddingRight: '5px',
        arrowColor: "",
        //transitionDuration: "1s",
        // timingFunc: "ease"
    };
    const config = {
        // animate: true,
        // arrowIcon: "V",
        // tabFocus: true
        openOnload: 0,
    };

    useEffect(() => {
        (async () => {
            try {
                const aiKd = url.searchParams.get('kd');
                const aiLoc = url.searchParams.get('open_ai_location');
                const aiCity = aiLoc ? aiLoc.split(',').map(p => p.trim().replace(/-/g, ' ')).join(', ') : '';
                const aiTopic = aiKd && aiKd !== 'null' ? aiKd : 'air duct cleaning';
                const searchKeyword = `I need from you 32 words about "${aiTopic}"${aiCity ? ` in ${aiCity}` : ''} and how we "Rocket Air Care" can help our clients with that kind of service. Give me that as a json file: title (3 words, include words from the service${aiCity ? ' and the city' : ''}, do not include the words "null" or "Rocket Air Care") and body`
                const resChat = await fetch(`https://genesis-platforms-8157acd2d107.herokuapp.com/api/GenesisOpenAi_Landing_Pages_Content_Creating`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        prompt: searchKeyword
                    })
                })
                const dataChat = await resChat.json()
                console.log(dataChat.content)
                setResponse(JSON.parse(dataChat.content))
            } catch (error) {
                console.log(error);
            }

            const getDerivedStateFromError = (error) => {
                console.log("123123");
                return { hasError: true };
            }
            const dsad = (error, errorInfo) => {
                console.log("123123");
            }
        })();
    }, []);
    return (
        <div className="AirDuct" id="homepage">
<Helmet>
    {/* <!-- TITLE --> */}
    <title>Rocket Air Care | Air Duct Cleaning, Inspection & Repair | 866-950-4606</title>	


    {/* <!-- META TITLE (max 35 characters) --> */}
    <meta name="title" property="title" content="Rocket Air Care | Air Duct Cleaning, Inspection & Repair | 866-950-4606" data-react-helmet="true" />
    <meta name="og:title" property="og:title" content="Rocket Air Care | Air Duct Cleaning, Inspection & Repair | 866-950-4606" data-react-helmet="true" />

    {/* <!-- META INFO --> */}
    <meta name="og:locale" property="og:locale" content="en_US" data-react-helmet="true" />
    <meta name="og:type" property="og:type" content="website" data-react-helmet="true" />
    <meta name="og:image" property="og:image" content="https://www.rocketaircare.com/og-airduct.jpg" data-react-helmet="true" />
    <meta name="og:url" property="og:url" content="https://www.rocketaircare.com/air-duct" data-react-helmet="true" />

    {/* <!-- DESCRIPTION (Title Case) --> */}
    <meta name="description" content="Rocket Air Duct Provides Professional Duct Cleaning, Inspections, And Repairs To Improve Airflow, Energy Efficiency, And Indoor Air Quality In Your Home." data-react-helmet="true" />
    <meta name="og:description" property="og:description" content="Rocket Air Duct Provides Professional Duct Cleaning, Inspections, And Repairs To Improve Airflow, Energy Efficiency, And Indoor Air Quality In Your Home." data-react-helmet="true" />

    {/* <!-- SITE NAME --> */}
    <meta name="og:site_name" property="og:site_name" content="Rocket Air Duct" data-react-helmet="true" />

    {/* <!-- KEYWORDS --> */}
    <meta name="keywords" content="Air Duct Cleaning, Air Duct Inspection, Duct Repair, Vent Cleaning, Airflow Testing, HVAC Duct Cleaning, Residential Air Ducts, Commercial Air Ducts, Indoor Air Quality, Dust Removal, Duct Sanitization, Duct Maintenance, Ventilation System Cleaning, Allergens In Ducts, Mold In Air Ducts, Rocket Air Duct Services" data-react-helmet="true" />
</Helmet>

            {/* MainBanner */}
            <div className="MainBanner" >
                <div className="MainBannerLeft">
                    <div className="MainBannerLeftRight">

                        <img className="bannerlogopng" src={require(`../../ImagesLogos/Logo1.png`)} />

                        <h1>Don't Sweat It, Call Rocket Air Care</h1>
                        <h4>Top-Rated <b>Air Duct Service</b> in {CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}</h4>
                        <h2>Rocket Air Care is the the leading Air Duct team in <b>{CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}</b>. Give us a call at <span>{CitiePhone}</span> to schedule your service.
                        </h2>
                        <h3><img src={require(`../../Images/check.png`)} />Affortable Pricing & No Hidden Fees</h3>
                        <h3><img src={require(`../../Images/check.png`)} />Licensed, Bonded, Insured!</h3>
                        <h3><img src={require(`../../Images/check.png`)} />Fully stocked trucks</h3>
                        <h3><img src={require(`../../Images/check.png`)} />1800+ 5-Star Reviews</h3>
                        <div className="MainBannerLeftButtons">
                            <a href={`tel:${CitiePhone}`} onClick={fireRocketCall}>Call Us Now!</a>
                            <a href={`tel:${CitiePhone}`} onClick={fireRocketCall}>{CitiePhone}<img src={require(`../../Images/telephone.png`)} /></a>
                        </div>
                        <div className="MainBannerLeftRated" >
                            <h3>Rated 5 on Google</h3>
                            <span>
                                <h4>5</h4>
                                <img fetchpriority="low" src={require(`../../Images/Google.png`)} />
                            </span>
                        </div>
                    </div>
                    <div className="MainBannerLeftLeft">
                        <BookAnAppointment CitiesData={CitiesData} CitiePhone={CitiePhone} />
                    </div>

                </div>
                <div className="MainBannerImg">
                    <img src={require(`../../ImagesLogos/logobanner.png`)} />
                </div>
            </div>
            {/* AirDuctReviews */}
            <div className="AirDuctReviews" id="reviews">
                <h1>Read Our Latest 5-Star Reviews</h1>
                <div className="AirDuctReviewsList">
                    <img className="bannerlogopng" src={require(`../../Images/review1airduct.png`)} />
                    <img className="bannerlogopng" src={require(`../../Images/review2airduct.png`)} />
                    <img className="bannerlogopng" src={require(`../../Images/review3airduct.png`)} />
                </div>
            </div>
            {/* GenesisAiContent — keyword-driven section, /local ads pages only */}
            <GenesisAiContent response={response} />
            {/* AirDuctBenefits */}
            <div className="AirDuctBenefits">
                <h1>Benefit of Clean Your <span>Air Duct</span></h1>
                <div className="AirDuctBenefitsBox">
                    <div className="AirDuctBenefitsBoxImg">
                        <img src={require(`../../Images/ben2.png`)} alt="Dust Problem" />
                    </div>
                    <div className="AirDuctBenefitsBoxBox">
                        <h2>Persistent Dust Everywhere?</h2>
                        <h3>No matter how often you clean, dust keeps coming back? Dirty air ducts could be the hidden problem, spreading particles throughout your home. Don’t worry—our team can clean your ducts and help keep your home dust-free.</h3>
                    </div>
                </div>
                <div className="AirDuctBenefitsBox">
                    <div className="AirDuctBenefitsBoxImg">
                        <img src={require(`../../Images/ben3.png`)} alt="Allergy Relief" />
                    </div>
                    <div className="AirDuctBenefitsBoxBox">
                        <h2>Allergies or Asthma Acting Up?</h2>
                        <h3>If your allergies or asthma seem worse than ever, your air ducts might be circulating allergens, dust, and harmful contaminants. Let us improve your indoor air quality and bring relief to you and your family.</h3>
                    </div>
                </div>
                <div className="AirDuctBenefitsBox">
                    <div className="AirDuctBenefitsBoxImg">
                        <img src={require(`../../Images/ben1.png`)} alt="Mold Issues" />
                    </div>
                    <div className="AirDuctBenefitsBoxBox">
                        <h2>Spotted Mold?</h2>
                        <h3>Seeing mold near your ducts? That’s a serious warning sign. Mold spores can spread through the air, putting your family’s health at risk. Our professional mold removal and duct cleaning services can restore a healthier environment.</h3>
                    </div>
                </div>
                <div className="AirDuctBenefitsBox">
                    <div className="AirDuctBenefitsBoxImg">
                        <img src={require(`../../Images/ben4.png`)} alt="Energy Savings" />
                    </div>
                    <div className="AirDuctBenefitsBoxBox">
                        <h2>Skyrocketing Energy Bills?</h2>
                        <h3>Noticing weaker airflow and higher energy costs? Dirty ducts could be forcing your HVAC system to work overtime, wasting energy and money. We’ll clean your ducts and optimize your HVAC system for better efficiency.</h3>
                    </div>
                </div>
                <h4>TAKE THE FIRST STEP TOWARD A HEALTHIER AND MORE <span>EFFICIENT HOME</span>, SCHEDULE YOUR AIR DUCT CLEANING TODAY!</h4>
                <div className="AirDuctBenefitsbutn">
                    <a href={`tel:${CitiePhone}`} onClick={fireRocketCall}>{CitiePhone}<img src={require(`../../Images/telephone.png`)} /></a>
                    <a href='#book'>SCHEDULE <span>&nbsp;ONLINE</span><img src={require(`../../Images/book.png`)} alt="Air Duct Cleaning | Air Duct Repair | Air Duct Services | Air Duct Inspection In Master," /></a>
                </div>
            </div>
            {/* MainBanner2Top2 */}
            <div className="MainBanner2Top2">
                <div className="MainBanner2TopBoxMenuShadow1"></div>
                <div className="MainBanner2TopBoxMenu">
                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/airduct1.png`)} alt="Air Duct Cleaning" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <h3>AIR DUCT CLEANING</h3>
                            <h2><img src={require(`../../Images/check.png`)} />Allergen Removal</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Duct Sanitization</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Mold Removal</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Air Quality Testing</h2>
                        </div>
                    </a>
                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/ductrepair.png`)} alt="Air Duct Cleaning" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <h3>AIR DUCT REPAIR</h3>
                            <h2><img src={require(`../../Images/check.png`)} />Duct Leak Repair</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Damaged Duct Replacement</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Sealing Gaps in Ducts</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Airflow Balancing</h2>
                        </div>
                    </a>
                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/uvlightin.png`)} alt="Air Duct Cleaning" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <h3>UV LIGHT & SANITATIONR</h3>
                            <h2><img src={require(`../../Images/check.png`)} />UV Light Installation</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Air Purification Systems</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Mold Prevention</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Energy-Efficient UV Systems</h2>
                        </div>
                    </a>
                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/dryercleaning.jpg`)} alt="Air Duct Cleaning" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <h3>DRYER VENT CLEANING</h3>
                            <h2><img src={require(`../../Images/check.png`)} />Lint Removal</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Clogged Vent Clearing</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Fire Hazard Prevention</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Vent Inspection & Repair</h2>
                        </div>
                    </a>
                </div>
                <div className="MainBanner2TopBoxMenuShadow2"></div>
            </div>

            {/* All home service categories — sub-categories grid */}
            {!location.pathname.startsWith("/local") && (<div className="CategoryBlocks CategoryBlocks-Hide-On-Local">
                {[
                    { key: "airduct", label: "Air Duct", href: "/airduct", match: (a) => /air duct|hvac duct|air vent|coil cleaning|mold removal from air|uv air|anti-microbial duct|indoor air quality|furnace cleaning/i.test(a.Title) },
                    { key: "chimney", label: "Chimney & Fireplace", href: "/chimney", match: (a) => /chimney|fireplace|creosote|smoke chamber|masonry|tuckpoint|wood stove|gas fireplace|pellet stove|insert/i.test(a.Title) },
                    { key: "dryer", label: "Dryer Vent", href: "/dryer", match: (a) => /dryer|lint|bird guard/i.test(a.Title) },
                    { key: "hvac", label: "HVAC", href: "/hvac", match: (a) => /hvac|^ac |furnace repair|furnace install|heat pump|mini-split|thermostat|refrigerant/i.test(a.Title) },
                    { key: "roofing", label: "Roofing & Gutters", href: "/roofing", match: (a) => /roof|gutter|skylight|soffit|fascia/i.test(a.Title) },
                ].map((cat) => {
                    const subs = AllServicesData.filter(cat.match).slice(0, 8);
                    if (subs.length === 0) return null;
                    return (
                        <div key={cat.key} className={`CategoryBlock CategoryBlock-${cat.key}`}>
                            <div className="CategoryBlockHeader">
                                <h2>{cat.label}</h2>
                                <a href={cat.href}>View {cat.label} Landing →</a>
                            </div>
                            <div className="CategoryBlockGrid">
                                {subs.map((s, i) => (
                                    <a key={i} href={s.Path} className="CategoryBlockItem">
                                        <h3>{s.Title}</h3>
                                        <p>{s.Full}</p>
                                        <span>Learn more →</span>
                                    </a>
                                ))}
                            </div>
                        </div>
                    );
                })}
            </div>)}

            <div className="AirDuctWeondawy">
                <img src={require(`../../ImagesLogos/logobanner2.png`)} alt="Air Duct Cleaning" />
                <h1>Stay calm, we're coming to you!</h1>

            </div>
            {/* airductbefore */}
            <div className="AirDuctBefore">
                <div className="AirDuctBeforeLeft">
                    <h1>THE IMPORTANCE OF CLEAN AIR DUCTS</h1>
                    <h2>Protect Your Health, Save Energy, and Breathe Easier</h2>
                    <h3>Your air ducts play a crucial role in maintaining the quality of the air you breathe at home. Over time, dust, allergens, mold, and other contaminants accumulate, circulating through your living space and potentially affecting your health. Dirty ducts can also strain your HVAC system, driving up energy bills and reducing efficiency. Regular air duct cleaning not only enhances indoor air quality but also extends the lifespan of your HVAC system, creating a healthier and more cost-effective environment for you and your family. Prioritize clean air—schedule a professional duct cleaning today!</h3>
                    <h2>Cleaner Air, Healthier Living—The Choice Is Yours</h2>
                    <h3>Regular air duct cleaning is not just about maintaining cleanliness; it's about safeguarding your family’s well-being. Polluted air can trigger allergies, worsen asthma, and spread harmful contaminants throughout your living space. Clean ducts promote better airflow, reducing strain on your HVAC system and ensuring your home feels comfortable year-round. Plus, you’ll enjoy fresher air, lower energy bills, and a longer-lasting HVAC system. Take control of your indoor environment and experience the difference clean air ducts can make.</h3>
                    <h4>Booking with Rocket AirCare is simple! Call us at <a href='tel:${CitiePhone}'>{CitiePhone}</a> or complete our <a href='#book'>online booking form</a>. Our team will confirm your appointment and be ready to assist you at your convenience.</h4>
                </div>
                <div className="AirDuctBeforeBox">
                    <ReactCompareImage leftImage={img22} rightImage={img23} />
                </div>
            </div>
            {/* HomePageGoogleBen */}
            <div className="HomePageGoogleBen">
                <div className="HomePageGoogleBenLEFT">
                    <img fetchpriority="low" src={require(`../../Images/Before1.jpeg`)} />
                </div>
                <div className="HomePageGoogleBenRIGHT">
                    <h1>ROCKET BENEFITS</h1>
                    <div className="HomePageGoogleBenRIGHTList">
                        <div className="HomePageGoogleBenRIGHTListBox">
                            <img src={require(`../../Images/check.png`)} />
                            <h2>
                                Highly Trained & Certified Technicians
                                <h3>- Our Technicians completed more than 2,500 hours of training in 2023</h3>
                                <h3>- Our Technicians complete 45+ hours yearly of weekly skills training</h3>
                            </h2>
                        </div>
                        <div className="HomePageGoogleBenRIGHTListBox">
                            <img src={require(`../../Images/check.png`)} />
                            <h2>
                                Fast Response Time
                                <h3>- 24/7 emergency appointments available</h3>
                            </h2>
                        </div>
                        <div className="HomePageGoogleBenRIGHTListBox">
                            <img src={require(`../../Images/check.png`)} />
                            <h2>
                                Satisfaction Guaranteed
                                <h3>- 1,800+ five-star reviews</h3>
                            </h2>
                        </div>
                        <div className="HomePageGoogleBenRIGHTListBox">
                            <img src={require(`../../Images/check.png`)} />
                            <h2>Fully Licensed & Insured</h2>
                        </div>
                        <div className="HomePageGoogleBenRIGHTListBox">
                            <img src={require(`../../Images/check.png`)} />
                            <h2>Friendly Customer Service</h2>
                        </div>
                    </div>
                </div>
            </div>
            {/* AirDuctGoodBY */}
            <div className="AirDuctGoodBY">
                <h1>SAY GOODBYE TO DIRT AND DUST IN YOUR AIR DUCTS</h1>
                <div className="HomePageGoogleFAQBorder"></div>
                <h2>Experience cleaner, healthier air with our professional air duct cleaning services.</h2>
                <div className="AirDuctGoodBYList">
                    <img src={require(`../../Images/11.jpg`)} />
                    <img src={require(`../../Images/43.jpg`)} />
                    <img src={require(`../../Images/23.jpg`)} />
                    <img src={require(`../../Images/65.jpg`)} />
                </div>
            </div>
            {/* MainBanner */}
            <div className="AirDuctBook">
                <div className="MainBannerLeftRight">
                    <h1>Book Your Air Duct Cleaning Online Now in {CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}</h1>
                    <h4>Top-Rated <b>Air Duct Service</b></h4>
                    <h2>Rocket Air Care: Your Trusted Air Duct Cleaning Team in <b>{CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}</b>. 📅 Schedule Your Appointment Online in less then a Minute</h2>
                    <h3><img src={require(`../../Images/check.png`)} /> Affordable Pricing & No Hidden Fees – Book Online Today!</h3>
                    <h3><img src={require(`../../Images/check.png`)} /> Licensed, Bonded, & Insured Professionals Ready to Serve You</h3>
                    <h3><img src={require(`../../Images/check.png`)} /> Fully Stocked Trucks for Next-Day Service – Schedule Now!</h3>
                    <h3><img src={require(`../../Images/check.png`)} /> Trusted by 1800+ 5-Star Reviews – Join Our Happy Customers!</h3>
                    <div className="MainBannerLeftButtons" id="book">
                        <a href={`tel:${CitiePhone}`} onClick={fireRocketCall}>Call Us Now!</a>
                        <a href={`tel:${CitiePhone}`} onClick={fireRocketCall}>{CitiePhone}<img src={require(`../../Images/telephone.png`)} /></a>
                    </div>
                    <div className="MainBannerLeftRated">
                        <h3>Rated 5 on Google</h3>
                        <span>
                            <h4>5</h4>
                            <img fetchpriority="low" src={require(`../../Images/Google.png`)} />
                        </span>
                    </div>
                </div>
                <div className="MainBannerLeftLeft">
                    <BookAnAppointment CitiesData={CitiesData} CitiePhone={CitiePhone} />
                </div>

            </div>
            {/* AirDuctHowit work */}
            <div className="AirDuctHowIt">
                <h1>How It Works</h1>
                <div className="HomePageGoogleFAQBorder"></div>
                <h2>All It Takes is Three Easy Steps</h2>
                <div className="AirDuctHowItList">
                    <div className="AirDuctHowItListBox">
                        <img className="bannerlogopng" src={require(`../../Images/howit1.png`)} />
                        <h3>STEP 1</h3>
                        <h4>Call Our Office</h4>
                        <h5>Give us a call at <a href={`tel:${CitiePhone}`} onClick={fireRocketCall}>{CitiePhone}</a> to speak to one of our experts regarding the issue you are experiencing.</h5>
                    </div>
                    <div className="AirDuctHowItListBox">
                        <img className="bannerlogopng" src={require(`../../Images/howit2.png`)} />
                        <h3>STEP 2</h3>
                        <h4>Expert Evaluation</h4>
                        <h5>We’ll send a licensed and highly trained expert to your home to conduct a comprehensive evaulation.</h5>
                    </div>
                    <div className="AirDuctHowItListBox">
                        <img className="bannerlogopng" src={require(`../../Images/howit3.png`)} />
                        <h3>STEP 1</h3>
                        <h4>Sit Back & Relax</h4>
                        <h5>Our team of expert HVAC technicians will solve all of your heating and air problems!</h5>
                    </div>
                </div>
                <h6>Give us a call at <a href={`tel:${CitiePhone}`} onClick={fireRocketCall}>{CitiePhone}</a> to get started.</h6>
            </div>
            {/* MainBanner2Top2 */}
            <div className="AirDuctServices" id="ourservices">
                <div className="MainBanner2TopBoxMenu">
                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/airduct1.png`)} alt="Air Duct Cleaning" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <div className="MainBanner2TopBoxBoxBoxBox">
                                <h3>AIR DUCT CLEANING</h3>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Allergen Removal</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Duct Sanitization</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Mold Removal</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Air Quality Testing</h2>
                            </div>
                            <h4>Breathe cleaner air with Rocket Air Care’s professional air duct cleaning services. Over time, dust, debris, and allergens build up in your air ducts, reducing air quality and efficiency. Our skilled technicians use advanced equipment to thoroughly clean your ducts, improving airflow and creating a healthier home environment. Whether it’s a routine cleaning or addressing allergy concerns, we’ve got you covered. Call Rocket Air Care today and enjoy fresher, healthier air for your family—your comfort is our priority!</h4>
                        </div>
                    </a>
                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/ductrepair.png`)} alt="Air Duct Cleaning" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <div className="MainBanner2TopBoxBoxBoxBox">
                                <h3>AIR DUCT REPAIR</h3>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Duct Leak Repair</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Damaged Duct Replacement</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Sealing Gaps in Ducts</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Airflow Balancing</h2>
                            </div>
                            <h4>Damaged air ducts can lead to energy loss, higher utility bills, and poor air quality. Rocket Air Care specializes in professional air duct repair to keep your HVAC system running smoothly. From sealing leaks to repairing damaged sections, our technicians ensure your system operates efficiently and safely. Don’t let faulty ducts compromise your comfort! Call Rocket Air Care today and experience the difference of expert service. We’ll restore your ducts and your peace of mind in no time.</h4>
                        </div>
                    </a>
                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/uvlightin.png`)} alt="Air Duct Cleaning" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <div className="MainBanner2TopBoxBoxBoxBox">
                                <h3>UV LIGHT & SANITATIONR</h3>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />UV Light Installation</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Air Purification Systems</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Mold Prevention</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Energy-Efficient UV Systems</h2>
                            </div>
                            <h4>Eliminate harmful bacteria and allergens with Rocket Air Care’s UV light and sanitation services. Our advanced UV technology kills up to 99% of airborne contaminants, ensuring your indoor air is as clean and healthy as possible. Perfect for allergy sufferers or anyone concerned about germs, our service improves air quality and protects your family. Trust Rocket Air Care for cutting-edge solutions that bring peace of mind. Call now to schedule your UV light and sanitation service and breathe easier!</h4>
                        </div>
                    </a>
                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/dryercleaning.jpg`)} alt="Air Duct Cleaning" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <div className="MainBanner2TopBoxBoxBoxBox">
                                <h3>DRYER VENT CLEANING</h3>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Lint Removal</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Clogged Vent Clearing</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Fire Hazard Prevention</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Vent Inspection & Repair</h2>
                            </div>
                            <h4>Prevent fire hazards and improve efficiency with Rocket Air Care’s dryer vent cleaning services. Clogged dryer vents are a leading cause of house fires and can increase energy bills. Our experienced technicians use powerful tools to remove lint and debris, restoring proper airflow to your dryer. Protect your home and save money with this essential service. Call Rocket Air Care today to schedule your dryer vent cleaning and enjoy peace of mind with a safer, more efficient home.</h4>
                        </div>
                    </a>
                </div>
            </div>
            {/* MainBanner4 */}
            <div className="MainBanner4">
                <div className="MainBanner4Right">
                    <h1>Our Comprehensive Air Duct Services</h1>
                    <h2>At Rocket Air Care, we offer a full suite of air duct services designed to improve your indoor air quality and HVAC system performance. Our services include professional air duct cleaning, detailed inspections, expert repairs, and routine maintenance. With advanced equipment and skilled technicians, we ensure your air ducts are free of dust, allergens, and debris, creating a cleaner, healthier, and more efficient home environment. Trust Rocket Air Care to keep your air ducts in peak condition!</h2>
                    <div className="MainBafnner4RightBenefits">
                        <a >Air duct cleaning</a>
                        <a >Professional air duct cleaning</a>
                        <a >Air duct repair</a>
                        <a >Dryer vent cleaning</a>
                        <a >UV light sanitation</a>
                        <a >Air quality testing</a>
                        <a >Mold removal</a>
                        <a >Allergen removal</a>
                        <a >HVAC system cleaning</a>
                        <a >Air duct inspections</a>
                        <a >Affordable air duct services</a>
                        <a >Licensed and insured technicians</a>
                        <a >Energy-efficient air care</a>
                        <a >Same-day air duct service</a>
                        <a >Fire hazard prevention</a>
                        <a >Indoor air quality improvement</a>
                        <a >Clogged vent clearing</a>
                        <a >Duct sanitization</a>
                        <a >Fully stocked service trucks</a>
                        <a >Residential air duct cleaning</a>
                    </div>
                </div>
            </div>
            {/* HomePageGoogleFAQ */}
            <div className="HomePageGoogleFAQ">
                <h1>ABOUT OUR {CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : ""} LOCATION</h1>
                <div className="HomePageGoogleFAQBorder"></div>
                <div className="HomePageGoogleFAQTop">
                    <div className="HomePageGoogleFAQTopLeft">
                        <h2>PROUDLY SERVING OUR LOCAL COMMUNITY</h2>
                        <div className="HomePageGoogleFAQBorder"></div>
                        <h3>At Rocket AirCare, we are dedicated to providing exceptional service to our community. For over 22 years, we have committed ourselves to delivering top-quality air duct cleaning services over {CitiesData && CitiesData.City ? CitiesData.City : ""}, ensuring healthier and more comfortable living environments. In addition to air duct cleaning, we also offer a range of services tailored to improve indoor air quality and meet the unique needs of our valued customers.</h3>
                        <div className="MainBannerLeftButtons">
                            <a href={`tel:${CitiePhone}`} onClick={fireRocketCall}>Call Us Now!<img fetchpriority="low" src={require(`../../Images/telephone.png`)} /></a>
                            <a href='#book'>SCHEDULE ONLINE<img src={require(`../../Images/book.png`)} alt="Chimney Sweep Cleaning Near Me Rocket Air Care" /></a>
                        </div>
                    </div>
                    <div className="HomePageGoogleFAQTopRight">
                        <img src={require(`../../ImagesLogos/logobanner.png`)} />
                    </div>
                </div>
                <h1>FREQUENTLY ASKED QUESTIONS</h1>
                <div className="HomePageGoogleFAQBorder"></div>
                <div className="MainBanner4FaqMore">
                    <Faq
                        data={data}
                        styles={styles}
                        config={config}
                    />
                </div>
            </div>
        </div>
    )
}

